import { render, staticRenderFns } from "./linkOverPayment.vue?vue&type=template&id=8f49e97c&"
import script from "./linkOverPayment.vue?vue&type=script&lang=js&"
export * from "./linkOverPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports